import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import React, { useCallback, useMemo, useState } from "react";

import { Loader } from "~/components/blocks";

import { Marker } from "./Marker";

export const DEFAULT_CENTER = {
  lat: 35.662725,
  lng: 139.731217,
} as const;
const DEFAULT_ZOOM = 16;
const STATIC_OPTIONS: google.maps.MapOptions = {
  gestureHandling: "none",
  fullscreenControl: false,
  zoomControl: false,
  disableDefaultUI: true,
  mapId: process.env.googleMapId,
};

const containerStyle = {
  height: "300px",
};

type Props = {
  lat: number;
  long: number;
};

export const Map = React.memo((props: Props) => {
  const [map, setMap] = useState<google.maps.Map | null>(null);
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.googleMapsApiKey,
    language: "ja",
    region: "JP",
    mapIds: [process.env.googleMapId],
  });

  const position = useMemo(
    () => ({ lat: props.lat, lng: props.long }),
    [props.lat, props.long],
  );

  const handleOnLoad = useCallback((map: google.maps.Map) => {
    setMap(map);
  }, []);

  return (
    <>
      {isLoaded ? (
        <GoogleMap
          mapContainerStyle={containerStyle}
          clickableIcons={false}
          options={STATIC_OPTIONS}
          center={position}
          zoom={DEFAULT_ZOOM}
          onLoad={handleOnLoad}
        >
          {map && <Marker position={position} map={map} />}
        </GoogleMap>
      ) : (
        <Loader open inside />
      )}
    </>
  );
});

Map.displayName = "Map";
